// extracted by mini-css-extract-plugin
export var numpadContainer = "_iv-1";
export var phoneButton = "_iv-0";